import { createSlice } from "@reduxjs/toolkit";
import {
  getModelCode,
} from "./modelCodeService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  modelCodeList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const modelCodeSlice = createSlice({
  name: "modelCode",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get Model List ---------- */
    builder
      .addCase(getModelCode.pending, (state) => {
        state.modelCodeList.status = STATUS.LOADING;
        state.modelCodeList.error = null;
      })
      .addCase(getModelCode.fulfilled, (state, action) => {
        state.modelCodeList.status = STATUS.SUCCEEDED;
        state.modelCodeList.data = action?.payload?.data || [];
      })
      .addCase(getModelCode.rejected, (state, action) => {
        state.modelCodeList.status = STATUS.FAILED;
        state.modelCodeList.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectModelCodeList = (state) =>
  state.modelCode.modelCodeList;

export default modelCodeSlice.reducer;
